/** Main JobStatuses ile uyumlu (models/index.js). */
export const JOB_STATUS = {
  RUNNING: 1,
  SUCCESS: 2,
  FAILURE: 3,
  SENDING: 4,
  DISCONNECTED: 5,
  QUEUED: 6,
  DECLINED: 7,
  RECONNECTING: 8,
};

export const JOB_STATUS_FILTER_OPTIONS = [
  { name: "Running", value: JOB_STATUS.RUNNING },
  { name: "Success", value: JOB_STATUS.SUCCESS },
  { name: "Failure", value: JOB_STATUS.FAILURE },
  { name: "Sending", value: JOB_STATUS.SENDING },
  { name: "Disconnected", value: JOB_STATUS.DISCONNECTED },
  { name: "Queue", value: JOB_STATUS.QUEUED },
  { name: "Declined", value: JOB_STATUS.DECLINED },
  { name: "Reconnecting", value: JOB_STATUS.RECONNECTING },
];

const CODE_TO_LABEL = {
  [JOB_STATUS.RUNNING]: "Running",
  [JOB_STATUS.SUCCESS]: "Success",
  [JOB_STATUS.FAILURE]: "Failure",
  [JOB_STATUS.SENDING]: "Sending",
  [JOB_STATUS.DISCONNECTED]: "Disconnected",
  [JOB_STATUS.QUEUED]: "Queue",
  [JOB_STATUS.DECLINED]: "Declined",
  [JOB_STATUS.RECONNECTING]: "Reconnecting",
};

const STRING_TO_CODE = {
  RUNNING: JOB_STATUS.RUNNING,
  SUCCESS: JOB_STATUS.SUCCESS,
  FAILURE: JOB_STATUS.FAILURE,
  SENDING: JOB_STATUS.SENDING,
  DISCONNECTED: JOB_STATUS.DISCONNECTED,
  QUEUE: JOB_STATUS.QUEUED,
  QUEUED: JOB_STATUS.QUEUED,
  DECLINED: JOB_STATUS.DECLINED,
  RECONNECTING: JOB_STATUS.RECONNECTING,
};

/** API'den gelen status (number veya string) → ekranda görünen etiket */
export function jobStatusLabel(status) {
  const code = jobStatusCode(status);
  if (code != null && CODE_TO_LABEL[code]) {
    return CODE_TO_LABEL[code];
  }
  if (status == null || status === "") {
    return "Unknown";
  }
  return String(status);
}

/** Status kodu (number); bilinmiyorsa null */
export function jobStatusCode(status) {
  if (status == null || status === "") {
    return null;
  }
  const n = Number(status);
  if (!Number.isNaN(n) && CODE_TO_LABEL[n]) {
    return n;
  }
  const key = String(status).toUpperCase();
  return STRING_TO_CODE[key] ?? null;
}

/** Jobs tablosu chip rengi — label veya kod kabul eder */
export function jobStatusChipColor(status) {
  const label = jobStatusLabel(status);
  switch (label) {
    case "Success":
      return "green";
    case "Failure":
      return "red";
    case "Running":
      return "yellow";
    case "Queue":
      return "purple";
    case "Sending":
      return "magenta";
    case "Disconnected":
      return "orange";
    case "Reconnecting":
      return "cyan";
    case "Declined":
      return "blue";
    default:
      return "grey";
  }
}

/** Dashboard grafik renkleri */
export function jobStatusChartColor(label) {
  switch (label) {
    case "Success":
      return "#4CAF50";
    case "Failure":
      return "#D50000";
    case "Running":
      return "#FFEB3B";
    case "Queue":
      return "#673AB7";
    case "Sending":
      return "#607D8B";
    case "Disconnected":
      return "#FF9800";
    case "Reconnecting":
      return "#00BCD4";
    case "Declined":
      return "#2196F3";
    case "Canceled":
    case "Cancelled":
      return "#9E9E9E";
    case "Waiting":
      return "#00BCD4";
    default:
      return "#663f5c";
  }
}

/** Elapsed time için hâlâ devam eden job status kodları */
export function isActiveJobStatusCode(code) {
  return [
    JOB_STATUS.RUNNING,
    JOB_STATUS.SENDING,
    JOB_STATUS.RECONNECTING,
    JOB_STATUS.QUEUED,
  ].includes(code);
}
